import { SEARCH_QUERY, SEARCH_CITIES } from "../../../../Utils/AllPagesQuriesAndMutations";

const EmtMarketRateConfig = [
  {
    name: "Emt_Market_Rates_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        type: "Date",
        // disabled:true
      },
      {
        id: Math.random() * 10,
        name: "From_City",
        label: "From City",
        masterName: "City_Search",
        type: "InputDropForQuery",
        dropdowncontent: SEARCH_CITIES,
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "To_City",
        label: "To City",
        masterName: "City_Search",
        type: "InputDropForQuery",
        dropdowncontent: SEARCH_CITIES,
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Weight_Guarantee",
        label: "Weight Guarantee",
        type: "number",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Rate_By",
        type: "select",
        dropdowncontent: ["Fixed", "Per ton"],
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Rate",
        label: "Rate",
        type: "number",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];

export { EmtMarketRateConfig };
